export enum Breakpoint {
    xs = 0, // mobileOnly:
    sm = 1, // tabletPortrait: 640px
    md = 2, // tabletLandscape: 960px
    lg = 3, // desktop: 1200px
    xl = 4, // desktopRetina: 1760px
}

export const BREAKPOINT_ORDER: Breakpoint[] = [
    Breakpoint.xs,
    Breakpoint.sm,
    Breakpoint.md,
    Breakpoint.lg,
    Breakpoint.xl,
];
